"use server";

import { auth } from "@/auth";
import { prisma } from "@/lib/prisma";
import { revalidatePath } from "next/cache";
import { redirect } from "next/navigation";

export async function updateProfile(formData: FormData) {
  const session = await auth();

  if (!session?.user?.id) return;

  const firstName = String(formData.get("firstName") || "");
  const lastName = String(formData.get("lastName") || "");
  const phone = String(formData.get("phone") || "");
  const address = String(formData.get("address") || "");
  const postalCode = String(formData.get("postalCode") || "");
  const city = String(formData.get("city") || "");

  await prisma.user.update({
    where: { id: session.user.id },
    data: {
      firstName,
      lastName,
      phone,
      address,
      postalCode,
      city,
    },
  });

  // Revalidate the compte page to reflect fresh data
  revalidatePath("/compte");

  // Redirect with a small success flag for UX feedback
  redirect("/compte?saved=1");
}